<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      buttonName="导出"
      @openAddDialog="exportInfo"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      buttonType="warning"
      :show="!isDaoC"
      addShowPower="/fin/memAcctDtlExport"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
      <el-form-item label="业务类型">
        <el-select v-model="formModel.busiType" filterable>
          <el-option
            v-for="item in busiTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="会员名称">
        <el-input
          v-model="formModel.realName"
          maxlength="50"
          placeholder="请输入会员名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="电话号码">
        <el-input
          v-model="formModel.phoneNumber"
          maxlength="50"
          placeholder="请输入电话号码"
        ></el-input>
      </el-form-item>
      <!--<el-form-item label="交易类型">-->
      <!--<el-select v-model="formModel.tranType">-->
      <!--<el-option-->
      <!--v-for="item in tranTypes"-->
      <!--:key="item.value"-->
      <!--:label="item.label"-->
      <!--:value="item.value">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
      <!--<el-form-item label="操作类型">-->
      <!--<el-select v-model="formModel.optType">-->
      <!--<el-option-->
      <!--v-for="item in optTypes"-->
      <!--:key="item.value"-->
      <!--:label="item.label"-->
      <!--:value="item.value">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
      <el-form-item label="变更日期">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="realName"
        label="会员名称"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tatId"
        label="机构简称"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tranId"
        label="订单号"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="电话号码"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <!--<el-table-column prop="operation" label="用户名" show-overflow-tooltip></el-table-column>-->
      <!--<el-table-column prop="operation" label="手机号" show-overflow-tooltip></el-table-column>-->
      <el-table-column
        prop="busiType"
        label="业务类型"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <!--<el-table-column prop="operationType" label="交易类型" min-width="100"   :formatter="formatTranTypee" show-overflow-tooltip >-->
      <!--<template slot-scope="scope">-->
      <!--<p v-if="scope.row.operationType == 1">返佣</p>-->
      <!--<p v-else-if="scope.row.operationType == 2">分润</p>-->
      <!--<p v-else-if="scope.row.operationType == 3">提现</p>-->
      <!--<p v-else-if="scope.row.operationType == 4">调账</p>-->
      <!--</template>-->
      <!--</el-table-column>-->
      <!--<el-table-column prop="operationDirection" label="操作类型" min-width="100" show-overflow-tooltip>-->
      <!--<template slot-scope="scope">-->
      <!--&lt;!&ndash;<p>{{scope.row.operationDirection == 1 ? '正向交易' : '负向交易'}}</p>&ndash;&gt;-->
      <!--<p :class="[{'text-green':scope.row.operationDirection == 1},{'text-red':scope.row.operationDirection == 2}]">-->
      <!--{{scope.row.operationDirection == 1 ? '+' : '-'}}</p>-->
      <!--</template>-->
      <!--</el-table-column>-->
      <el-table-column
        prop="operationAmt"
        label="变动金额（元）"
        min-width="130"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.operationAmt * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="balAmt"
        label="变动后余额（元）"
        min-width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.balAmt * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <el-table-column label="来源" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">
          <p>{{ scope.row.fromName }} {{ scope.row.fromTel }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="变动时间"
        min-width="160"
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";

import FinanceService from "service/FinanceService";
import OrganService from "service/OrganService";
import StatisticsService from "service/StatisticsService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";
import TimeRange from "service/constant/TimeRange";

export default {
  name: "inventedrewarddetail",
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
  },
  data() {
    return {
      formModel: {
        tatSimpleId: "",
        tranType: "",
        optType: "",
        time: [],
        phoneNumber: "",
        busiType: "",
        realName: "",
      },
      busiTypes: [],
      all: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      tableData: [],
      page: {},
      params: {},
      optTypes: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "收入（+）",
        },
        {
          value: "2",
          label: "支出（-）",
        },
      ],
      submitService: FinanceService.getMemRewardAccDtl,
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.page = this.$refs.commonTable.page;
    // this.getList();

    this.getTypeNames("红包类型", (res) => {
      this.busiTypes = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
  },
  computed: {
    isDaoC() {
      return this.roleDaoC.indexOf(this.userInfo.userName) > -1;
    },
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      this.params = {
        userId: this.userId,
        tatSimpleId: this.formModel.tatSimpleId,
        tranType: this.formModel.tranType,
        optType: this.formModel.optType,
        busiType: this.formModel.busiType,
        startDate: this.formModel.time[0],
        endDate: this.formModel.time[1],
        realName: this.formModel.realName.trim(),
        phoneNumber: this.formModel.phoneNumber.trim(),
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      if (this.formModel.time.length == 0) {
        delete this.params.startDate;
        delete this.params.endDate;
      }

      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    formatTranTypee(row, column, cellValue) {
      let value = "";
      this.tranTypes.forEach((item) => {
        if (item.value == cellValue) {
          value = item.label;
        }
      });
      return value ? value : "--";
    },
    exportInfo() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "memAcctDtlExport",
            "",
            "/fin/"
          )
        : "";
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        FinanceService.getMemRewardAccDtl,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/InventedRewardDetail.vue